(() => {
  const init = root => {
    if (root.dataset.hmReady) return;
    root.dataset.hmReady = 'true';
    const read = selector => JSON.parse(root.querySelector(selector)?.textContent || '[]');
    const life = new AbortController();
    const observers = [];
    const sticky = root.querySelector('[data-hm-sticky]');
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){observers.forEach(observer=>observer.disconnect());life.abort();}},{signal:life.signal});
    const setText = (selector,value) => {const element=root.querySelector(selector);if(element)element.textContent=value;};
    const variants = read('[data-hm-variants]');
    const images = read('[data-hm-images]');
    const text = read('[data-hm-strings]');
    const giftOffer = root.querySelector('[data-hm-gift-offer]') ? read('[data-hm-gift-offer]') : null;
    const giftUnit = root.querySelector('[data-hm-gift-unit]');
    const giftInputs = () => [...(giftUnit?.querySelectorAll('[data-hm-gift-option]') || [])];
    const giftVariant = () => giftOffer?.variants.find(v=>giftInputs().every(input=>input.value&&v.options[Number(input.dataset.hmGiftOption)]===input.value));
    const form = root.querySelector('.hm-form');
    const add = root.querySelector('[data-hm-add]');
    const message = root.querySelector('[data-hm-message]');
    const stickyAdd = root.querySelector('[data-hm-sticky-add]');
    const pack = root.dataset.pack === 'true';
    const units = [...root.querySelectorAll('[data-hm-unit]')];
    const panels = [...root.querySelectorAll('[data-hm-panel]')];
    const config = root.querySelector('[data-hm-config]');
    const slides = [...root.querySelectorAll('[data-hm-slide]')];
    const thumbs = [...root.querySelectorAll('[data-hm-thumb]')];
    const dots = [...root.querySelectorAll('[data-hm-dot]')];
    const bars = [...root.querySelectorAll('[data-hm-progress]')];
    const shippingInfo = root.querySelector('[data-hm-shipping]');
    const shipping = shippingInfo ? JSON.parse(shippingInfo.textContent) : null;
    const sample = root.dataset.moneyExample || '';
    const currency = new Intl.NumberFormat(root.dataset.locale || 'en',{style:'currency',currency:root.dataset.currency || 'EUR'});
    const money = cents => {
      if(sample.includes('1,00')){
        const [prefix,suffix] = sample.split('1,00');
        return prefix + new Intl.NumberFormat('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100) + (suffix || '');
      }
      return currency.format(cents/100);
    };
    let active = 0;
    let complete = false;
    let busy = false;
    const gallery = root.querySelector('[data-hm-gallery]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let dragged = false;
    let carousel = null;
    const syncGallery = (index = 0) => {
      if(!gallery || !slides.length)return;
      if(index!==active)slides[active]?.querySelector('video')?.pause();
      active=index;
      thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));
      dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===active)));
      bars.forEach((bar,i)=>bar.classList.toggle('is-active',i===active));
      slides.forEach((slide,i)=>slide.querySelectorAll('button,a').forEach(link=>link.tabIndex=i===active?0:-1));
      setText('[data-hm-count]',`${active+1} / ${slides.length}`);
      const thumb=thumbs[active];
      const strip=thumb?.parentElement;
      if(thumb && strip){
        const left=thumb.offsetLeft-strip.offsetLeft;
        if(left<strip.scrollLeft || left+thumb.offsetWidth>strip.scrollLeft+strip.clientWidth)strip.scrollTo({left:Math.max(0,left-strip.clientWidth/2+thumb.offsetWidth/2),behavior:reduced.matches?'instant':'smooth'});
      }
      for(const i of new Set([active,(active-1+slides.length)%slides.length,(active+1)%slides.length]))slides[i]?.querySelectorAll('img').forEach(img=>{img.loading='eager';img.decode?.().catch(()=>{});});
    };
    const show = index => {
      if(!gallery || !slides.length)return;
      const next=((index%slides.length)+slides.length)%slides.length;
      if(carousel)carousel.select(next,false,reduced.matches);
      else{gallery.scrollTo({left:next*gallery.clientWidth,behavior:reduced.matches?'instant':'smooth'});syncGallery(next);}
    };
    if(gallery && slides.length>1 && window.theme?.Flickity){
      gallery.classList.add('hle-theme-carousel');
      carousel=new window.theme.Flickity(gallery,{
        cellSelector:'[data-hm-slide]',
        wrapAround:true,
        pageDots:false,
        adaptiveHeight:true,
        prevNextButtons:false
      });
      carousel.on('pointerDown',()=>{dragged=false;});
      carousel.on('dragStart',()=>gallery.classList.add('is-moving'));
      carousel.on('dragMove',()=>{dragged=true;});
      carousel.on('staticClick',()=>{dragged=false;});
      carousel.on('change',index=>syncGallery(index));
      carousel.on('settle',()=>gallery.classList.remove('is-moving'));
      window.theme.flickitySmoothScrolling(gallery);
      const resize=new ResizeObserver(()=>carousel.resize());
      resize.observe(gallery);observers.push(resize);
      life.signal.addEventListener('abort',()=>{carousel.destroy();gallery.classList.remove('hle-theme-carousel');},{once:true});
    }
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i)));
    root.querySelector('[data-hm-prev]')?.addEventListener('click',()=>show(active-1));
    root.querySelector('[data-hm-next]')?.addEventListener('click',()=>show(active+1));
    syncGallery();
    const dialog = root.querySelector('[data-hm-lightbox]');
    root.querySelectorAll('[data-hm-zoom]').forEach(button=>button.addEventListener('click',()=>{if(button.closest('[data-hm-gallery]')&&dragged){dragged=false;return;}const image=root.querySelector('[data-hm-full-image]');image.src=button.dataset.fullSrc||button.querySelector('img')?.src;image.alt=button.querySelector('img')?.alt||'';dialog.setAttribute('aria-label',image.alt);dialog.showModal();}));
    root.querySelector('[data-hm-close]')?.addEventListener('click',()=>dialog.close());
    dialog?.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
    if(!form || !add || !variants.length)return;
    const qty = () => pack ? Number(form.querySelector('[name="hm_pack"]:checked').value) : 1;
    const inputs = scope => [...scope.querySelectorAll('[data-hm-option]')];
    const variantFor = scope => variants.find(v=>inputs(scope).every(input=>input.value&&v.options[Number(input.dataset.hmOption)]===input.value));
    const activeUnits = () => units.slice(0,qty());
    const imageFor = finish => {
      const name=finish.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
      const metal=['silver','argento','argent','argenté','prata','argint','plata','plateado','silber'].includes(name)?'silver':'gold';
      return images.find(image=>{const alt=(image.alt || '').toLowerCase();return alt.includes(metal)&&(alt.includes('studio')||alt.includes('catalog'));}) || images.find(image=>(image.alt || '').toLowerCase().includes(metal));
    };
    const syncColour = scope => {
      scope.querySelectorAll('[data-hm-colour]').forEach(button=>{
        const input=scope.querySelector(`[data-hm-option="${button.dataset.hmIndex}"]`);
        const selected=input.value===button.dataset.hmColour;
        button.setAttribute('aria-pressed',String(selected));
        if(selected){
          scope.querySelector('[data-hm-finish-label]').textContent=input.value;
          const image=imageFor(input.value);
          const preview=scope.querySelector('.hm-unit-image img');
          if(preview&&image){preview.src=image.url;preview.removeAttribute('srcset');preview.alt=image.alt;}
        }
      });
    };
    const update = () => {
      message.textContent='';
      root.querySelector('[data-hm-ready]')?.classList.remove('is-warning');
      let total=0;
      if(pack){
        const count=qty();
        const panel=panels.find(p=>Number(p.dataset.hmPanel)===count);
        if(config.parentElement!==panel)panel.append(config);
        panels.forEach(p=>p.hidden=p!==panel);
        root.querySelectorAll('[data-hm-bundle]').forEach(card=>card.classList.toggle('is-selected',Number(card.dataset.hmBundle)===count));
        units.forEach((unit,i)=>{
          unit.hidden=i>=count;
          inputs(unit).forEach(input=>{input.disabled=i>=count;if(input.tagName==='SELECT')input.required=i<count;});
          unit.querySelector('[data-hm-unit-free]').hidden=!!giftOffer&&count===4||i<count/2||i>=count;
          syncColour(unit);
        });
        const selected=activeUnits();
        const ready=selected.filter(unit=>variantFor(unit)?.available).length;
        complete=ready===count;
        const subtotal=selected.reduce((sum,unit)=>sum+(variantFor(unit)?.price || variants[0].price),0);
        total=giftOffer&&count===4?giftOffer.price:Math.round(subtotal/2);
        if(giftUnit){giftUnit.hidden=count!==4;giftInputs().forEach(input=>{input.disabled=count!==4;if(input.tagName==='SELECT')input.required=count===4;});if(count===4)complete=complete&&!!giftVariant()?.available;}
        setText('[data-hm-ready]',`${ready}/${count} ${text.selected}`);
        setText('[data-hm-hero-original]',money(subtotal+(giftOffer&&count===4?giftOffer.necklacePrice:0)));
        setText('[data-hm-hero-quantity]',`${count} ${text.pieces}`);
        setText('[data-hm-sticky-count]',`${count} ${text.pieces}`);
      }else{
        const variant=variantFor(form);
        complete=!!variant?.available;
        total=variant?.price || variants[0].price;
        syncColour(form);
        if(variant){form.querySelector('[data-hm-variant]').value=variant.id;const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
      }
      setText('[data-hm-hero-total]',money(total));
      const availability=root.querySelector('[data-hm-availability]');
      const selectedVariants=pack?activeUnits().map(variantFor):[variantFor(form)];
      const canOrder=selectedVariants.every(v=>!v||v.available);
      if(availability&&shipping){availability.textContent=canOrder?shipping.available:shipping.unavailable;root.querySelector('[data-hm-availability-dot]').classList.toggle('is-unavailable',!canOrder);}
      setText('[data-hm-sticky-price]',money(total));
      setText('[data-hm-sticky-count]',pack ? `${qty()} ${text.pieces}` : root.querySelector('h1')?.textContent || '');
      add.disabled=busy;
      add.textContent=busy?text.adding:`${text.add} · ${money(total)}`;
      if(stickyAdd)stickyAdd.disabled=busy;
      if(stickyAdd)stickyAdd.textContent=busy?text.adding:text.add;
    };
    form.querySelectorAll('select,input[type="radio"]').forEach(input=>input.addEventListener('change',update));
    form.querySelectorAll('[data-hm-colour]').forEach(button=>button.addEventListener('click',()=>{
      const scope=pack?button.closest('[data-hm-unit]'):form;
      scope.querySelector(`[data-hm-option="${button.dataset.hmIndex}"]`).value=button.dataset.hmColour;
      const image=imageFor(button.dataset.hmColour);
      const index=image?slides.findIndex(slide=>slide.dataset.imageId===String(image.id)):-1;
      if(index>=0)show(index);
      update();
    }));
    form.querySelectorAll('[data-hm-gift-colour]').forEach(button=>button.addEventListener('click',()=>{
      giftUnit.querySelector('[data-hm-gift-option="0"]').value=button.dataset.hmGiftColour;
      giftUnit.querySelectorAll('[data-hm-gift-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      giftUnit.querySelector('[data-hm-gift-finish]').textContent=button.dataset.hmGiftColour;
      const image=giftUnit.querySelector('[data-hm-gift-image]');image.src=image.dataset[button.dataset.hmGiftMetal];const bonus=root.querySelector('.hm-offer-gift [data-hm-zoom]');if(bonus){bonus.dataset.fullSrc=image.src;bonus.querySelector('img').src=image.src;}update();
    }));
    stickyAdd?.addEventListener('click',()=>{
      if(complete)form.requestSubmit();
      else {
        const notice=pack?root.querySelector('[data-hm-ready]'):message;
        if(notice){notice.textContent=text.choose;notice.classList.add('is-warning');}
        const target=pack?root.querySelector('.hm-bundle.is-selected'):form;
        target?.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'center'});
      }
    });
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      if(!complete||busy||!form.reportValidity())return;
      busy=true;update();
      try{
        const headers={Accept:'application/json'};
        const grouped=new Map();
        const addVariant=(id,quantity,kind)=>{const key=`${id}-${kind}`;const line=grouped.get(key);if(line)line.quantity+=quantity;else grouped.set(key,{id,quantity,properties:{_horus_bonds:kind}});};
        if(pack&&giftOffer&&qty()===4){
          const properties={_horus_bonds:'initial-gift-set',[text.includesLabel]:text.giftContents};
          activeUnits().forEach((unit,i)=>{const v=variantFor(unit);const select=unit.querySelector('select');properties[`${text.braceletLabel} ${i+1}`]=`${v.options[0]} / ${select?.selectedOptions[0]?.textContent || v.options[1]}`;properties[`_bracelet_${i+1}_variant`]=String(v.id);});
          const necklace=giftVariant();const letter=giftUnit.querySelector('select').selectedOptions[0].textContent;
          properties[text.necklaceLabel]=`${necklace.options[0]} / ${letter}`;properties._necklace_variant=String(necklace.id);
          grouped.set('gift-set',{id:giftOffer.id,quantity:1,properties});
        }else if(pack)activeUnits().forEach(unit=>addVariant(variantFor(unit).id,1,'hug-bogo'));
        else addVariant(variantFor(form).id,1,'collection');
        const body=JSON.stringify({items:[...grouped.values()]});
        headers['Content-Type']='application/json';
        const response=await fetch(root.dataset.addUrl,{method:'POST',headers,body});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||text.error);
        busy=false;update();
        await window.HorusBondsCart.open(add);
      }catch(error){busy=false;update();message.textContent=error.message||text.error;}
    });
    if(sticky){
      const responsive=matchMedia('(max-width: 1099px)');
      const viewport=window.visualViewport;
      let stickyFrame=0;
      const syncSticky=()=>{
        stickyFrame=0;
        const top=viewport?.offsetTop||0;
        const height=viewport?.height||window.innerHeight;
        const rect=add.getBoundingClientRect();
        const passedMain=rect.bottom<=top;
        sticky.hidden=!responsive.matches||!passedMain||!!(viewport&&Math.abs(viewport.scale-1)>.05);
        if(!sticky.hidden)sticky.style.setProperty('--hm-sticky-y',`${Math.max(0,Math.round(top+height-sticky.offsetHeight))}px`);
      };
      const queueSticky=()=>{if(!stickyFrame)stickyFrame=requestAnimationFrame(syncSticky);};
      const observer=new IntersectionObserver(queueSticky,{threshold:[0,.1,1]});
      observer.observe(add);observers.push(observer);
      const resizeObserver=new ResizeObserver(queueSticky);
      resizeObserver.observe(sticky);resizeObserver.observe(add);observers.push(resizeObserver);
      for(const event of ['scroll','resize','orientationchange','pageshow'])window.addEventListener(event,queueSticky,{passive:true,signal:life.signal});
      for(const event of ['scroll','resize','scrollend'])viewport?.addEventListener(event,queueSticky,{passive:true,signal:life.signal});
      responsive.addEventListener('change',queueSticky,{signal:life.signal});
      life.signal.addEventListener('abort',()=>cancelAnimationFrame(stickyFrame),{once:true});
      queueSticky();
    }
    const film=root.querySelector('[data-hm-film]');
    const play=root.querySelector('[data-hm-film-play]');
    if(film&&play){
      play.addEventListener('click',()=>film.play().catch(()=>{}));
      film.addEventListener('play',()=>play.hidden=true);
      film.addEventListener('pause',()=>play.hidden=false);
      const filmObserver=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)film.pause();},{threshold:.05});
      filmObserver.observe(film);observers.push(filmObserver);
    }
    const restoreChoices = () => {
      update();
    };
    window.addEventListener('pageshow',restoreChoices,{signal:life.signal});
    restoreChoices();
  };
  if(window.Shopify?.designMode)document.addEventListener('shopify:block:select',event=>{const details=event.target.matches('details')?event.target:event.target.querySelector('details');if(details)details.open=true;});
  const boot=()=>document.querySelectorAll('[data-hm-product]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();


